import { type RouteLocationAsRelativeGeneric, type RouteLocationNormalizedLoadedGeneric } from 'vue-router'

import type { BreadcrumbItem } from '@/components/PageBreadcrumbs.vue'

export const buildBreadcrumb = (
  route: RouteLocationNormalizedLoadedGeneric,
  to: RouteLocationAsRelativeGeneric,
  text: string,
): BreadcrumbItem => {
  return {
    to: route.name === to.name ? undefined : to,
    text,
  }
}
